import { Link } from 'react-router-dom';
import { cn } from 'lib/utils';
import WhatsAppIcon from 'components/ui/WhatsAppIcon';

const variants = {
  primary:
    'bg-Mora-brown text-white hover:bg-Mora-dark shadow-md shadow-Mora-brown/20 hover:shadow-lg hover:-translate-y-0.5',
  secondary:
    'border-2 border-Mora-brown text-Mora-brown hover:bg-Mora-brown hover:text-white',
  whatsapp:
    'bg-[#25D366] text-white hover:bg-[#1da851] shadow-md shadow-[#25D366]/20 hover:shadow-lg hover:-translate-y-0.5',
  ghost:
    'text-Mora-brown hover:bg-Mora-beige/60',
  outline:
    'border-2 border-Mora-brown/30 text-Mora-brown hover:border-Mora-brown hover:bg-Mora-brown hover:text-white',
};

const sizes = {
  sm: 'px-3.5 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm',
  md: 'px-4 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-semibold',
  lg: 'px-5 sm:px-8 py-3 sm:py-3.5 text-sm sm:text-base font-semibold',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  external,
  className,
  ...props
}) {
  const classes = cn(
    'inline-flex items-center justify-center gap-2 rounded-xl font-body whitespace-nowrap',
    'transition-all duration-300 ease-out',
    'focus-visible:outline-2 focus-visible:outline-Mora-caramel focus-visible:outline-offset-2',
    'active:scale-[0.98]',
    variants[variant],
    sizes[size],
    className
  );

  const icon = variant === 'whatsapp' ? <WhatsAppIcon className="w-5 h-5 flex-shrink-0" /> : null;

  const isHashLink = typeof href === 'string' && href.startsWith('#');
  const isExternal = external || (typeof href === 'string' && (href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:')));

  if (href) {
    if (isHashLink) {
      return (
        <a
          href={href}
          onClick={(e) => {
            e.preventDefault();
            document.getElementById(href.substring(1))?.scrollIntoView({ behavior: 'smooth' });
          }}
          className={classes}
          {...props}
        >
          {icon}
          {children}
        </a>
      );
    }
    if (isExternal) {
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={classes}
          {...props}
        >
          {icon}
          {children}
        </a>
      );
    }
    return (
      <Link to={href} className={classes} {...props}>
        {icon}
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {icon}
      {children}
    </button>
  );
}
